import * as api from "app/api/planning"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import * as getCodesByCategoryActions from "../codesByCategory/codesByCategory.actions"
import * as notificationActions from "../notifications/notifications.actions"
import * as actions from "./codes.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* getCodesFlow(): SagaIterator {
  try {
    const response = yield call(api.getCodes)
    yield put(actions.getCodesSuccess(response && response.data))
  } catch (e) {
    yield put(actions.getCodesFail(e))
    yield call(handleError, { error: e })
  }
}

export function* deleteCodesByIdFlow(action: actions.DeleteCodesByIdAction): SagaIterator {
  try {
    const { id } = action.payload
    yield call(api.deleteCodes, id)
    yield put(actions.deleteCodesByIdSuccess())
    yield put(actions.getCodes())
  } catch (e) {
    yield put(actions.deleteCodesByIdFail(e))
    yield call(handleError, { error: e })
  }
}

export function* postCodesFlow(action: actions.PostCodesAction): SagaIterator {
  try {
    const { data } = action.payload
    const response = yield call(api.postCodes, data)
    yield put(actions.postCodesSuccess(response && response.data))
    yield put(
      notificationActions.show({
        id: "postCodesSuccess",
        message: "notifications.codes.post.success",
        variant: "success",
      }),
    )
    yield put(getCodesByCategoryActions.getCodesByCategory(response.data.category))
  } catch (e) {
    yield put(actions.postCodesFail(e))
    yield call(handleError, { error: e })
  }
}

export function* patchCodesFlow(action: actions.PatchCodesAction): SagaIterator {
  try {
    const { data } = action.payload
    const response = yield call(api.patchCodes, data)
    yield put(actions.patchCodesSuccess(response && response.data))
    yield put(getCodesByCategoryActions.getCodesByCategory(response.data.category))
    yield put(
      notificationActions.show({
        id: "patchCodesSuccess",
        message: "notifications.codes.patch.success",
        values: {
          title: data.title,
        },
        variant: "success",
      }),
    )
  } catch (e) {
    yield put(actions.patchCodesFail(e))
    yield call(handleError, { error: e })
  }
}

export function* patchCodeOrderFlow(action: actions.PatchCodeOrderAction): SagaIterator {
  try {
    const { id, order, category } = action.payload
    yield call(api.patchCodeOrder, id, { order }, { category })
    yield put(actions.patchCodeOrderSuccess())
    yield put(getCodesByCategoryActions.getCodesByCategory(category))
    yield put(actions.getCodes())
  } catch (e) {
    yield put(actions.patchCodeOrderFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* codesSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getCodesFlow)
  yield takeLatest(actions.Types.PATCH, patchCodesFlow)
  yield takeLatest(actions.Types.PATCH_ORDER, patchCodeOrderFlow)
  yield takeLatest(actions.Types.POST, postCodesFlow)
}
